import React from 'react'
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom'
import {InstantSearch, Hits, Highlight} from 'react-instantsearch/dom';
import {connectSearchBox} from 'react-instantsearch/connectors';
import './style.css'
import Topic from "./Topic/";

const SearchBox = connectSearchBox(
  ({query, refine}) =>
    <div className="searchbox-container">
        <div class="input-group  search-box">
          <input type="text"
                  placeholder="Search"
                 value={query}
                 onChange={e => refine(e.target.value)}
                 className="form-control"/>
        </div>
    </div>
);

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
      let router =
          <div>
            <Switch>
              <Route path='/teacher/learn/:id' component={Topic} />
              <Route exact path="/teacher/learn" render={() => {
                return(
                    <div className="learn-container" style={{"paddingTop":"25px"}}>
                      <InstantSearch
                          appId="2TMQLT5H8U"
                          apiKey="bdd7ad59e1017c678b25be971e33fe6f"
                          indexName="learn"
                          attributesToHighlight="body"
                      >
                        <SearchBox />
                        <Search />
                      </InstantSearch>
                    </div>
                )
              }} />
            </Switch>
          </div>;
      return (
          <Router>
            <div>
              {router}
            </div>
          </Router>
      );
    }
  }




function SearchResult({hit}) {
  console.log(hit.youth);
  var body = <Highlight attributeName="description" hit={hit} tagName="mark" />;

  if(hit.image) {
    return (
      <Link to={"learn/"+hit.objectID}>
        <div className="panel panel-default">
          <div className="panel-heading" style={{"paddingTop": "0px", "paddingRight": "0px", "paddingLeft": "0px", "overflow": "hidden"}}>
            <div style={{"paddingTop": "10px"}}>{hit.title}</div>
          </div>
          {body}
        </div>
    </Link>
    );
  } else {
    return (
      <Link to={"learn/"+hit.objectID}>
        <div className="panel panel-default">
          <div className="panel-heading">
            {hit.title}
          </div>
        </div>
    </Link>
    );
  }

};


class Search extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
      <Hits hitComponent={SearchResult} />
    )
  }
}

/*
<input type="text" class="form-control"
  value={this.state.query}
  onChange={this.onChangeQuery}
  style={{
  marginBottom: "20px",
  height: "50px",
  fontSize: "25pt"}} placeholder="Search..." />
  */



// WEBPACK FOOTER //
// ./src/components/Learn/index.js